// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as BlacklistPartnerRepoConfig from "./BlacklistPartnerRepoConfig.bs.js";

var dummySuccessResponse = {
      "message": "Partner blacklisted successfully",
      "status": "success"
    };

function blacklistPartner(payload, _country) {
  return new Promise((function (resolve, param) {
                  setTimeout((function (param) {
                          return resolve({
                                      TAG: /* Success */0,
                                      _0: dummySuccessResponse
                                    });
                        }), 1000);
                  
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BlacklistPartnerRepoConfig.BlacklistPartnerResponseConverter.execute, result);
                        });
            });
}

var BlacklistPartnerRepo = {
  blacklistPartner: blacklistPartner
};

export {
  BlacklistPartnerRepo ,
  
}
/* BlacklistPartnerRepoConfig Not a pure module */
